module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-menu'), _vm._v(" "), _c('app-content'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('app-snackbar'), _vm._v(" "), _c('app-informacao')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a40399e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-layouts/layout.vue
// module id = 401
// module chunks = 34